import {useEffect} from 'react'
import {useMe} from '@/features/authentication/queries/useMe'
import {USER_ROLE_GUEST} from '@/utilities/constants/user'
import {LocalStorageManager} from '@/utilities/localStorage'
import {GuestTypeV3} from '@/features/authentication/types'
import {useRootStore} from '@/store'
import {selectGetUltimateStatusModal} from '@/store/selectors'

export const useUltimateStatus = () => {
    const {data: userData} = useMe()
    const user = userData?.type === USER_ROLE_GUEST ? (userData as GuestTypeV3) : null

    const {openModal: openGetUltimateStatusModal} = useRootStore(selectGetUltimateStatusModal)

    const ultimateOffer = user?.typeAttributes?.ultimateOffer
    const isRefusedUltimateStatus = LocalStorageManager.refusedUltimateStatus.get()

    const isShownUltimateStatusModalFirstTime = LocalStorageManager.shownUltimateStatusModalFirstTime.get()
    const isUltimateStatusOfferAvailable =
        ultimateOffer?.isUltimateStatusOfferAvailable &&
        !isRefusedUltimateStatus &&
        !isShownUltimateStatusModalFirstTime

    useEffect(() => {
        if (isUltimateStatusOfferAvailable) {
            openGetUltimateStatusModal({})
        }
    }, [isUltimateStatusOfferAvailable])
}
